<template>
    <main>
        <div class="header"></div>
        <div class="error">
            <div class="center">
                <div class="middle">
                    <div class="num">404</div>
                    <div class="message">您访问的页面不存在</div>
                    <div class="btn" @click="util.toLink('/')">返回首页</div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import Crumbs from "../../components/pc/Crumbs";
    export default {
        name: 'error',
        data() {
            return {
                query:"",
            }
        },
        components:{
            Crumbs
        },
        computed:{
            crumbs() {
                return [
                    {title:'Error'},
                ]
            },
        },
        methods: {

        },
        mounted() {
            this.query = this.$route.query;
            this.util.showBottom(true);
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .header{position: fixed;top:0;left:0;width: 100%;height:80px;text-align: center;color: #fff;border-bottom: 1px solid rgba(255,255,255,.2);z-index: 99;background: url("~@/assets/image/20.jpg") no-repeat center top;background-size: 100% 800px;}
    .error{margin: 0 auto;height:800px;background: url("~@/assets/image/20.jpg") no-repeat center top;background-size: 100% 800px;text-align: center;
        .center{display: inline-block;
            .middle{color: #fff;height:800px;
                .num{font-size: 200px;}
                .message{height:50px;font-size: 35px;line-height: 50px;letter-spacing: 5px;}
                .btn{width: 200px; display: inline-block; height:50px;line-height: 50px;margin: 30px auto 0; text-align: center;font-size: 18px;color:#fff;background: #3176c8;transition: all .3s ease;cursor: pointer;}
            }
        }
    }
</style>

